import React from 'react';
import { Tag } from 'lucide-react';
import { estiloDaCor, type Etiqueta } from '../../../src/lib/etiquetasUc';

const TAMANHOS = {
  /** Nos cards e linhas: discreta, do tamanho das outras etiquetas da lista. */
  lista: { classe: 'text-[9px] px-1.5 py-0.5 gap-1', icone: 9 },
  /** Na janela de etiquetas: legível para escolher. */
  janela: { classe: 'text-xs px-2 py-0.5 gap-1.5', icone: 12 },
};

/** Uma etiqueta: pílula sólida na cor escolhida, explicação ao passar o mouse. */
export const EtiquetaUcPill: React.FC<{
  etiqueta: Pick<Etiqueta, 'texto' | 'cor' | 'descricao'>;
  tamanho?: keyof typeof TAMANHOS;
}> = ({ etiqueta, tamanho = 'lista' }) => (
  <span
    className={`flex items-center w-fit max-w-full font-bold text-white rounded-full shadow-sm whitespace-nowrap ${TAMANHOS[tamanho].classe} ${estiloDaCor(etiqueta.cor).pilula}`}
    title={etiqueta.descricao || etiqueta.texto}
  >
    <Tag size={TAMANHOS[tamanho].icone} className="shrink-0" />
    <span className="truncate">{etiqueta.texto || 'Etiqueta'}</span>
  </span>
);

/**
 * Etiquetas da UC seguidas do botão que abre a janela de etiquetas. O botão só aparece
 * para quem pode mexer (`onAbrir` definido) e fica desligado quando a fatura não tem UC
 * cadastrada — não há onde pendurar a etiqueta.
 */
export const EtiquetasDaUc: React.FC<{
  etiquetas?: Etiqueta[];
  ucCadastrada: boolean;
  onAbrir?: () => void;
}> = ({ etiquetas, ucCadastrada, onAbrir }) => {
  if (!etiquetas?.length && !onAbrir) return null;
  return (
    <div className="flex flex-wrap items-center gap-1">
      {etiquetas?.map(e => <EtiquetaUcPill key={e.id} etiqueta={e} />)}
      {onAbrir && (
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); if (ucCadastrada) onAbrir(); }}
          disabled={!ucCadastrada}
          title={ucCadastrada ? 'Etiquetas desta UC' : 'UC não cadastrada: não dá para pôr etiqueta'}
          aria-label="Etiquetas desta UC"
          className="flex items-center justify-center min-w-[22px] h-[22px] px-1 rounded-full border border-dashed border-gray-300 dark:border-gray-600 text-gray-400 hover:text-fuchsia-600 hover:border-fuchsia-400 hover:bg-fuchsia-50 dark:hover:bg-fuchsia-900/20 dark:hover:text-fuchsia-400 transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent disabled:hover:text-gray-400 disabled:hover:border-gray-300"
        >
          <Tag size={11} />
          {!etiquetas?.length && <span className="text-[9px] font-semibold ml-0.5">+</span>}
        </button>
      )}
    </div>
  );
};
